export interface IRoutesInfo {
  getAppPath: () => string
  getInitialPagePath: () => string
  getPageSubpath: (page: string) => string
}

interface IRoutesData {
  rootPath: string
  subpagesPathMask?: string
}

export class RoutesHelper implements IRoutesInfo {
  private routeData: IRoutesData

  constructor(routeData: IRoutesData) {
    this.routeData = routeData
  }

  public getAppPath = () => this.routeData.subpagesPathMask || this.routeData.rootPath

  public getInitialPagePath = () => this.routeData.rootPath

  public getPageSubpath = (page: string) => `${this.getAppPath()}/${page}`
}
